import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '新型冠状病毒感染的肺炎疫情实时追踪';

const route: RouteConfig = {
  path: '/20200128SARI',
  name: 'SARI',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
